import React from 'react';
import styles from './Card.module.css';

const Card = ({
  children,
  variant = 'default',
  padding = 'medium',
  hoverable = false,
  onClick,
  className = '',
  as = 'div',
  ariaLabel,
  ...props
}) => {
  const Component = as;
  
  const classNames = [
    styles.card,
    styles[variant],
    styles[`padding-${padding}`],
    hoverable && styles.hoverable,
    onClick && styles.clickable,
    className
  ].filter(Boolean).join(' ');

  return (
    <Component
      className={classNames}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick(e);
        }
      } : undefined}
      aria-label={ariaLabel}
      {...props}
    >
      {children}
    </Component>
  );
};

const CardHeader = ({ children, className = '', ...props }) => (
  <div className={`${styles.header} ${className}`} {...props}>
    {children}
  </div>
);

const CardTitle = ({ children, as = 'h3', className = '', ...props }) => {
  const Component = as;
  return (
    <Component className={`${styles.title} ${className}`} {...props}>
      {children}
    </Component>
  );
};

const CardSubtitle = ({ children, className = '', ...props }) => (
  <p className={`${styles.subtitle} ${className}`} {...props}>
    {children}
  </p>
);

const CardBody = ({ children, className = '', ...props }) => (
  <div className={`${styles.body} ${className}`} {...props}>
    {children}
  </div>
);

const CardFooter = ({ children, className = '', separator = true, ...props }) => (
  <div 
    className={`${styles.footer} ${separator ? styles.footerSeparator : ''} ${className}`} 
    {...props}
  >
    {children}
  </div>
);

const CardImage = ({ src, alt, className = '', aspectRatio = '16/9', ...props }) => (
  <div 
    className={`${styles.imageWrapper} ${className}`}
    style={{ aspectRatio }}
    {...props}
  >
    <img 
      src={src} 
      alt={alt} 
      className={styles.image}
      loading="lazy"
    />
  </div>
);

Card.Header = CardHeader;
Card.Title = CardTitle;
Card.Subtitle = CardSubtitle;
Card.Body = CardBody;
Card.Footer = CardFooter;
Card.Image = CardImage;

export default Card; 